import type { CSSProperties } from 'react';

// A --berg-* token, as the CSS variable name (e.g. '--berg-green-soft').
export type TokenVar = `--berg-${string}`;

// Sets the colour the `card-wash` utility radiates from the top-left corner.
export function washStyle(token: TokenVar): CSSProperties {
  return { ['--wash' as string]: `var(${token})` };
}
